import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { searchTransfers as searchTransfersApi } from '../api/acatsSearchApi'
import { AcatsSearchDto } from '../api/types'
import { HttpResponseStatusCodes } from '../constants'
import { TEMPORARILY_UNAVAILABLE, TRANSFER_RETRIEVAL_FAILED } from './constants'
import { RoutesEnum } from '../types/RoutesEnum'
import assembleQuery from '../containers/providers/helpers/assembleQuery'
import { History } from 'history'

export const SEARCH_TRANSFERS = 'SEARCH_TRANSFERS'
export const SEARCH_TRANSFERS_SUCCESS = 'SEARCH_TRANSFERS_SUCCESS'
export const SEARCH_TRANSFERS_FAILURE = 'SEARCH_TRANSFERS_FAILURE'

export const searchTransfers = (
  dispatch: Dispatch,
  history: History,
  acatsSearchDto?: AcatsSearchDto
) => {
  dispatch({ type: SEARCH_TRANSFERS, acatsSearchDto })
  searchTransfersApi(acatsSearchDto)
    .then((response: AxiosResponse) => {
      const {
        data: { acats: transferResults },
      } = response
      dispatch({ type: SEARCH_TRANSFERS_SUCCESS, transferResults })

      const initiateTransfer = (acatControlNumber: number | undefined) =>
        history.push(`/${RoutesEnum.TransferReview}/${acatControlNumber}`)

      const updateSearchPath = () =>
        history.replace(
          `${history.location.pathname}${assembleQuery(acatsSearchDto)}`,
          {
            acatsTransferFilters: acatsSearchDto,
          }
        )
      if (transferResults.length === 1) {
        const acatControlNumber = transferResults[0]?.acatControlNumber
        const accountNumber = transferResults[0]?.accountNumber
        // FEECM-17598: Removed Number() conversion - acatControlNumber is now string type
        if (
          (acatControlNumber &&
            acatControlNumber === acatsSearchDto?.acatControlNumber) ||
          (accountNumber && accountNumber === acatsSearchDto?.accountNumber)
        ) {
          initiateTransfer(acatControlNumber)
        } else {
          updateSearchPath()
        }
      } else {
        updateSearchPath()
      }
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : TRANSFER_RETRIEVAL_FAILED
      dispatch({ type: SEARCH_TRANSFERS_FAILURE, errorMessage })
    })
}
